import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { InformationPreviewComponent } from './components/information-preview/information-preview.component';
import { InnoliveTeaserComponent } from './components/innolive-teaser/innolive-teaser.component';
import { DashboardComponent } from './dashboard.component';
import { CompatibilityInfoDialogComponent } from './dialog/compatibility-info-dialog/compatibility-info-dialog.component';
import { StreetlightsWidgetDialogComponent } from './dialog/streetlights-widget-dialog/streetlights-widget-dialog.component';
import { TeaserMainModule } from './../teaser-main/teaser-main.module';

@NgModule({
  declarations: [DashboardComponent, InformationPreviewComponent, StreetlightsWidgetDialogComponent, CompatibilityInfoDialogComponent, InnoliveTeaserComponent],
  imports: [CommonModule, SharedModule, RouterModule, TeaserMainModule],
})
export class DashboardModule {}
